<template>
    <div class="container">
        <div class="dashboard">
            <div class="dashboard__rightpanel">
                <div class="white-box">
                    <PlanSelection
                        v-if="!showPaymentOptions"
                        :isBackButtonVisible="true"
                        :isCreatePortfolio="isCreatePortfolio"
                        :isEditPortfolio="isEditPortfolio"
                        :currentPortfolio="portfolio"
                        @success="cartPlanSelected"
                        @portfolio="portfolioHandler"
                        @goBack="goBack"
                    />
                    <PaymentComponent
                        v-else
                        :portfolio="portfolio"
                        :transactionPurpose="'portfolio'"
                        @goBack="goBack"
                        :showProduct="false"
                        :showEscrow="true"
                        :hideBankTransfer="true"
                        :customProps="customProps"
                        :escrowBalance="escrowBalance"
                        :disableAmountField="disableAmountField"
                        :investmentAmount="amount"
                        :hideMinimumInvest="hideMinimumInvest"
                    />
                </div>
            </div>
            <SidePanel/>
        </div>
    </div>
</template>

<script>
import SidePanel from '@/components/dashboard/dashboardSidePanel.vue'
import PaymentComponent from '@/components/common/paymentComponent/paymentComponent.vue'
import PlanSelection from '@/components/lenderOnboarding/planSelection'

export default {
    name: 'Plans',
    components: {
        PlanSelection,
        PaymentComponent,
        SidePanel
    },
    data () {
        return {
            hideMinimumInvest: true,
            portfolio: null,
            showPaymentOptions: false,
            escrowBalance: 0,
            disableAmountField: false,
            amount: null,
            isSelectPlan: false,
            isCreatePortfolio: true,
            isEditPortfolio: false,
            customProps: {
                hideContinueButton: true
            }
        }
    },
    mounted () {
        if (this.$route.query.investmentType === 'manual') {
            this.showPaymentOptions = true
            this.disableAmountField = true
        }
    },
    methods: {
        portfolioHandler (data) {
            this.portfolio = data
            this.isCreatePortfolio = false
            this.isEditPortfolio = true
        },
        cartPlanSelected (data) {
            this.showPaymentOptions = true
            this.$store.commit('portfolio/setPortfolio', data)
        },
        planSelected () {
            this.isSelectPlan = true
        },
        goBack () {
            this.showPaymentOptions = false
            this.isSelectPlan = false
            this.$router.push('/invest')
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/components/dashboard/dashboard.scss";

.dashboard__actions {
    justify-content: flex-end;
}

.register--or {
    @include size(100%, 1px, block);
    background-color: $badge;
    position: relative;
    margin: 30px 0;

    @media (min-width: 992px) {
        margin: 40px 0;
    }

    span {
        position: absolute;
        font-size: $font-size-md;
        font-weight: $font-weight-medium;
        background-color: $white;
        padding: 5px 10px;
        left: 50%;
        transform: translateX(-50%);
        top: -18px;
    }
}
</style>
